import { useEffect } from "react";

function ScrollToHashOnLoad({children}: {children: React.ReactNode}) {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash.split("?")[0]);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return <>{children}</>;
}

export default ScrollToHashOnLoad;